import { render, staticRenderFns } from "./i18nDropdown.vue?vue&type=template&id=28c83a9b"
import script from "./i18nDropdown.vue?vue&type=script&lang=ts"
export * from "./i18nDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports